/*
 * @Description: 等级销售搜模板管理
 * @Author: 杨志航
 * @Date: 2026-02-12 13:48:24
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Drawer,
  Input,
  Button,
  Select,
  Alert,
  Popconfirm,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import AddSaleTemplate from '../module/AddSaleTemplate'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const SaleTemplate = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [addVisible, setAddVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [projectList, setProjectList] = useState([])

  useEffect(() => {
    getSearchData()
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getAchSaleTplList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    currentPage = 1
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 编辑
  const handleEdit = data => {
    setEditData(data)
    setAddVisible(true)
  }

  const getSearchData = () => {
    Promise.all([
      api.getsysProjectChilds({ pid: 0 }),
    ]).then(list => {
      setProjectList(list[0])
    })
  }

  const handleAdd = () => {
    setEditData({})
    setAddVisible(true)
  }

  const handleDel = id => {
    setLoading(true)
    api.delAchSaleTpl({
      id
    }).then(() => {
      message.success('删除成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <div className="form-box">
          <FormItem label="等级销售模板">
            {getFieldDecorator('fileName')(<Input placeholder="请输入等级销售模板" />)}
          </FormItem>
          <FormItem label="关联项目">
            {getFieldDecorator('projectId')(<Select 
              placeholder="请选择关联项目"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={handleAdd}>新增</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
      >
        <Column 
          title="等级销售模板名称" 
          dataIndex="fileName"
          render={(text, record) => <a href={record.fileInfo?.url} target='_blank'>{text}</a>} 
        />
        <Column title="关联项目" dataIndex="projectName" />
        <Column title="使用人数" dataIndex="usedNum" />
        <Column title="创建人" dataIndex="addByName" />     
        <Column title="创建时间" dataIndex="addTime" />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={100}
          render={(text, record) => (
            <>
              <a onClick={() => handleEdit(record)}>编辑</a>
              <Popconfirm 
                title="请确认是否删除?" 
                onConfirm={() => handleDel(record.id)}
              >
                <a style={{ marginLeft: '10px' }}>删除</a>
              </Popconfirm>
            </>
          )}
        />
      </Table>
    </div>
    <Drawer
      title={editData.id ? '编辑' : '新增'}
      width={600}
      onClose={() => setAddVisible(false)}
      visible={addVisible}
      destroyOnClose={true}
    >
      <AddSaleTemplate 
        setAddVisible={setAddVisible}
        getList={getList}
        editData={editData}
        projectList={projectList}
      />
    </Drawer>
  </>
}

export default Form.create()(SaleTemplate)
